export enum FileStatus {
  Empty,
  Loading,
  LoadedWithSuccess,
  LoadedWithError,
}
